import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { snakeToTitleCase } from '@domain-group/javascript-utils'

import useTeamMember from '@hooks/useTeamMember'

import { confirmDelete } from '@functions/entity'

import { TeamMemberModel } from '@models/types'

interface TeamMemberListItemProps {
  teamMember: TeamMemberModel,
}

const TeamMemberListItem = (props: TeamMemberListItemProps) => {
  const { teamMember } = props

  const {
    teamMember: {
      member_role, team_lead,
    },
    callbacks: {
      createOrEditAdminTeamMember,
      deleteTeamMember: deleteFn,
    },
    // @ts-expect-error TS2339
    user: { full_name },
  } = useTeamMember(teamMember)

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    strings: {
      deleteString: 'remove',
      entityName: 'Team Member',
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={snakeToTitleCase(member_role)}
      title={full_name}
    >
      {team_lead && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.TertiaryText>
          Team Lead
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      )}

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          // @ts-expect-error TS2554
          onClick={() => createOrEditAdminTeamMember(teamMember)}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          // @ts-expect-error TS2345
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default TeamMemberListItem
